var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulbIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7143 9.99043C19.7143 9.49683 20.0197 9.06295 20.4252 8.77102C21.3824 8.08192 22 6.99473 22 5.77154C22 3.68857 20.2091 2 18 2C15.7909 2 14 3.68857 14 5.77154C14 6.99473 14.6176 8.08192 15.5748 8.77102C15.9803 9.06295 16.2857 9.49683 16.2857 9.99043C16.2857 10.3385 16.5732 10.6207 16.9278 10.6207H19.0722C19.4268 10.6207 19.7143 10.3385 19.7143 9.99043Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1574 12.3131C16.1574 11.9338 16.4707 11.6262 16.8571 11.6262H19.1429C19.5293 11.6262 19.8426 11.9338 19.8426 12.3131C19.8426 12.6925 19.5293 13 19.1429 13H16.8571C16.4707 13 16.1574 12.6925 16.1574 12.3131Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.8C10.2949 11.8 11.75 10.2778 11.75 8.4C11.75 6.52223 10.2949 5 8.5 5C6.70507 5 5.25 6.52223 5.25 8.4C5.25 10.2778 6.70507 11.8 8.5 11.8Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 13.5C2.72754 13.5 2 14.2611 2 15.2C2 18.9555 4.91015 22 8.5 22C12.0899 22 15 18.9555 15 15.2C15 14.2611 14.2725 13.5 13.375 13.5H3.625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbIdea);
export default __webpack_public_path__ + "static/media/bulb-idea.07b2636f53cb7af342b5ebaa08c1bd9d.svg";
export { ForwardRef as ReactComponent };